import {Authority} from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore

// prettier-ignore
const Ads = () => import('@/entities/publication/ads.vue');
const Publication = () => import('@/entities/publication/publication.vue');
// prettier-ignore
const Customer = () => import('@/entities/customer/customer.vue');
// prettier-ignore
const Campaign = () => import('@/entities/campaign/campaign.vue');
// prettier-ignore
const CampaignDetails = () => import('@/entities/campaign/campaign-details.vue');
const MyCampaigns = () => import('@/entities/campaign/my-campaigns.vue');
const MyCampaignDetails = () => import('@/entities/campaign/my-campaign-details.vue');
// prettier-ignore
const CampaignLink = () => import('@/entities/campaign-link/campaign-link-details.vue');
const ReportsPage = () => import('@/entities/report/ReportsPage.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here
export default [
    {
        path: '/publication',
        name: 'Publication',
        component: Publication,
        meta: {authorities: [Authority.MODERATOR, Authority.ADMIN]},
    },
    {
        path: '/ads',
        name: 'Ads',
        component: Ads,
        meta: {authorities: [Authority.MODERATOR, Authority.ADMIN]},
    },
    {
        path: '/customer/:id?',
        name: 'Customer',
        component: Customer,
        meta: {authorities: [Authority.MODERATOR, Authority.ADMIN]},
    },
    {
        path: '/campaign',
        name: 'Campaigns',
        component: Campaign,
        meta: {
            authorities: [Authority.MODERATOR, Authority.ADMIN],
        },
    },
    {
        path: '/campaign/:campaignId/view',
        name: '{name}',
        component: CampaignDetails,
        meta: {
            authorities: [Authority.MODERATOR, Authority.ADMIN, Authority.USER],
            breadcrumbs: [
                {
                    text: 'Campaigns',
                    href: '/campaign',
                },
            ],
        },
    },
    {
        path: '/my-campaigns',
        name: 'My Campaigns',
        component: MyCampaigns,
        meta: {
            authorities: [Authority.USER, Authority.ADMIN],
        },
    },
    {
        path: '/my-campaigns/:campaignId/view',
        name: '{name}',
        component: MyCampaignDetails,
        meta: {
            authorities: [Authority.ADMIN, Authority.USER],
            breadcrumbs: [
                {
                    text: 'Campaigns',
                    href: '/my-campaigns',
                },
            ],
        },
    },
    {
        path: '/campaign-link/:campaignLinkId',
        name: 'Campaign',
        component: CampaignLink,
    },
    {
        path: '/reports',
        name: 'Reports',
        component: ReportsPage,
        authorities: [Authority.ADMIN, Authority.MODERATOR],
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
];
